import classNames from "classnames";
import PropTypes from "prop-types";

function Box({title, footer, children, className, boxContentClassName}) {
    const boxClassName = classNames('box', className);
    const contentClassName = classNames('box__content', boxContentClassName);

    return (
        <div className={boxClassName}>
            {title && <div className="box__title">{title}</div>}
            <div className={contentClassName}>{children}</div>
            {footer && <div className="box__footer">{footer}</div>}
        </div>
    )
}

Box.propTypes = {
    title: PropTypes.string,
}

export default Box;
